import { render, staticRenderFns } from "./ToolbarAdminLanguageDialog.vue?vue&type=template&id=f80a46de&"
import script from "./ToolbarAdminLanguageDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ToolbarAdminLanguageDialog.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports